<template>
  <full-container>
    <template slot="header">
      <total style="margin-bottom: 16px" />
      <div class="toolbar">
        <el-form inline size="small">
          <el-form-item>
            <el-select
              style="width: 100px"
              clearable
              v-model="queryParams.state"
              placeholder="订单状态"
              @change="onSearch()"
            >
              <el-option
                v-for="item in stateOptions"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              style="width: 220px"
              type="daterange"
              v-model="queryParams.dateSpan"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="onSearch()"
            />
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="queryParams.keyWord"
              clearable
              placeholder="订单号/客户名称"
            >
              <template slot="append">
                <el-button icon="el-icon-search" @click="onSearch()" />
              </template>
            </el-input>
          </el-form-item>
        </el-form>
        <el-button-group>
          <el-button
            v-action="'/api/Mall/Order/Submit'"
            type="primary"
            size="small"
            @click="$router.push({ path: 'form' })"
            >新建订单</el-button
          >
          <el-button
            v-action="'/api/Mall/Order/Download'"
            icon="el-icon-download"
            size="small"
            @click="onDownload"
          />
        </el-button-group>
      </div>
    </template>
    <!--表格-->
    <el-table v-loading="loading" :data="datalist.Items" height="100%">
      <el-table-column label="类别" min-width="80">
        <template slot-scope="{ row }">
          {{ $utils.meta.format("branch", row.Type) }}
        </template>
      </el-table-column>
      <el-table-column label="订单编号" min-width="130" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <el-link type="primary" @click="currentTarget = row">
            NO.{{ row.Code }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="客户单位" min-width="240">
        <template slot-scope="{ row }">
          <el-tooltip placement="top">
            <div class="tip-content" slot="content">
              <p><label>联系人：</label>{{ row.Linkman }}</p>
              <p><label>联系电话：</label>{{ row.Linktel }}</p>
              <p><label>收货地址：</label>{{ row.Address }}</p>
            </div>
            <el-link>{{ row.CustomerName }}</el-link>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="金额合计" min-width="100">
        <template slot-scope="{ row }">
          <label class="text-price text-danger">{{ row.Amount }}</label>
        </template>
      </el-table-column>
      <el-table-column prop="Submiter" label="经办人" min-width="100" />
      <el-table-column label="订单时间" width="140">
        <template slot-scope="{ row }">
          {{ $utils.common.parseTime(row.CreateTime, "{y}-{m}-{d} {h}:{i}") }}
        </template>
      </el-table-column>
      <el-table-column label="打印次数" min-width="100">
        <template slot-scope="{ row }"> 已打印 {{ row.Printime }} 次 </template>
      </el-table-column>
      <el-table-column label="状态/操作" width="100" align="center">
        <template slot-scope="{ row }">
          <el-dropdown>
            <el-tag size="small" :type="stateColor(row.State)">
              {{ row.StateText }}
              <i class="el-icon-arrow-down" />
            </el-tag>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-action="'/api/Mall/Order/Submit'"
                :disabled="row.State != 0"
                @click.native="
                  $router.push({ path: `/mall/order/form/${row.Id}` })
                "
              >
                修改
              </el-dropdown-item>
              <el-dropdown-item
                v-action="'/api/Mall/Order/Confirm'"
                :disabled="row.State != 0"
                @click.native="onConfirm(row)"
              >
                确认
              </el-dropdown-item>
              <el-dropdown-item
                v-action="'/api/Mall/Order/Approval'"
                :disabled="row.State != 1"
                @click.native="onApprove(row)"
              >
                审核
              </el-dropdown-item>
              <el-dropdown-item
                v-action="'/api/Mall/Order/Recall'"
                :disabled="row.State == 0"
                @click.native="onRecall(row)"
              >
                重置
              </el-dropdown-item>
              <el-dropdown-item
                v-action="'/api/Mall/Order/Revoke'"
                :disabled="row.State == -1"
                @click.native="onRevoke(row)"
              >
                作废
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <el-pagination
      slot="footer"
      background
      :page-size="queryParams.size"
      :total="datalist.TotalCount"
      @current-change="onSearch"
    />

    <!--详情抽屉-->
    <el-drawer
      :size="1000"
      @close="currentTarget = {}"
      :visible="!!currentTarget.Id"
    >
      <div slot="title" style="margin-bottom: 20px">
        <el-link
          icon="el-icon-caret-right"
          type="primary"
          @click="$router.push({ path: `detail/${currentTarget.Id}` })"
          >进入详情页</el-link
        >
      </div>
      <detail :id="currentTarget.Id" :key="currentTarget.Id" />
    </el-drawer>
  </full-container>
</template>


<script>
import applyForm from "@/views/company/audit/apply.vue";
import approveForm from "./approve.vue";
export default {
  components: {
    total: () => import("./_total.vue"),
    detail: () => import("./detail.vue"),
  },
  data() {
    return {
      time: null,
      loading: false,
      currentTarget: {},
      datalist: {},
      queryParams: {
        index: 1,
        size: 20,
      },
      stateOptions: [
        {
          text: "已作废",
          value: -1,
        },
        {
          text: "待确认",
          value: 0,
        },
        {
          text: "待审核",
          value: 1,
        },
        {
          text: "已审定",
          value: 9,
        },
      ],
    };
  },
  computed: {
    stateColor() {
      return (state) => {
        switch (state) {
          case -1:
            return "info";
          case 0:
            return "primary";
          case 1:
            return "warning";
          case 9:
            return "success";
          default:
            return null;
        }
      };
    },
  },
  destroyed() {
    //离开页面是销毁轮询
    clearInterval(this.timer);
  },
  created() {
    //默认执行一次
    this.loadData();
    // 实现轮询
    this.timer = window.setInterval(() => {
      setTimeout(this.loadData(), 0);
    }, 1000 * 60);
  },
  methods: {
    // 查询参数
    onSearch(val = 1) {
      this.queryParams.index = val;
      this.loadData();
    },
    // 信息列表
    loadData() {
      this.loading = true;
      this.$apis.mall.order
        .list(this.queryParams)
        .then((res) => {
          this.datalist = res;
        })
        .catch((e) => {
          this.$message.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 下载数据
    onDownload() {
      this.$confirm(
        "此操作将根据当前条件下载数据到Execl中,数据过多时需要花费一定时间才能完成操作，是否继续？",
        `下载数据（xls）`,
        {
          center: true,
          type: "warning",
        }
      ).then(() => {
        //开始下载
        this.loading = true;
        this.$apis.mall.order
          .download(this.queryParams)
          .then((res) => {
            this.$message({ message: res, type: "success" });
          })
          .catch((e) => {
            this.$message.error(e || "操作失败");
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    //确认
    onConfirm(row) {
      this.$prompt(null, `确认${row.Code}`, {
        inputType: "textarea",
        inputPlaceholder: "备注信息...",
        callback: (action, { inputValue }) => {
          if (action == "confirm") {
            this.$apis.mall.order
              .confirm({
                id: row.Id,
                msg: inputValue,
              })
              .then(() => {
                this.$message({
                  message: "执行成功，订单已确认！",
                  type: "success",
                });
                this.loadData();
              })
              .catch((e) => {
                this.$message.error(e || "系统错误");
              });
          }
        },
      });
    },

    //作废
    onRevoke(row) {
      this.$prompt(null, `作废${row.Code}`, {
        inputType: "textarea",
        inputPlaceholder: "作废原因...",
        callback: (action, { inputValue }) => {
          if (action == "confirm") {
            this.$apis.mall.order
              .revoke({
                id: row.Id,
                msg: inputValue,
              })
              .then(() => {
                this.$message({
                  message: "执行成功，订单已作废！",
                  type: "success",
                });
                this.loadData();
              })
              .catch((e) => {
                this.$message.error(e || "系统错误");
              });
          }
        },
      });
    },
    //重置
    onRecall(row) {
      this.$prompt(null, `重置${row.Code}`, {
        inputType: "textarea",
        inputPlaceholder: "重置原因...",
        callback: (action, { inputValue }) => {
          if (action == "confirm") {
            this.$apis.mall.order
              .recall({
                id: row.Id,
                msg: inputValue,
              })
              .then(() => {
                this.$message({
                  message: "执行成功，订单已重置为待确认状态！",
                  type: "success",
                });
                this.loadData();
              })
              .catch((e) => {
                this.$message.error(e || "系统错误");
              });
          }
        },
      });
    },

    //审核
    onApprove(row) {
      this.$layer.iframe({
        title: `审核${row.Code}`,
        area: ["400px", "auto"],
        content: {
          content: approveForm,
          parent: this,
          data: {
            id: row.Id,
            callback: (res) => {
              if (res) {
                this.loadData();
              } else {
                this.onApply(row);
              }
            },
          },
        },
      });
    },

    //转审
    onApply(row) {
      this.$layer.iframe({
        title: `转审${row.Code}`,
        area: ["400px", "auto"],
        content: {
          content: applyForm,
          parent: this,
          data: {
            id: row.Id,
            msg: `${row.CustomerName}订单${row.Code}申请审核`,
            mode: "Mall-Order",
            callback: this.loadData,
          },
        },
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.tip-content {
  line-height: 1.6;

  label {
    display: inline-block;
    text-align: justify;
    text-align-last: justify;
    width: 5em;
  }
}
</style>